import Vue from 'vue'
import VueRouter from 'vue-router'
import DiagramPreview from '../views/DiagramPreview.vue'
import MermaidSyntax from '../views/MermaidSyntax.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: MermaidSyntax
  },
  {
    path: '/diagram',
    name: 'DiagramPreview',
    component: DiagramPreview
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router